<!--
 Created by Xuz on 2019/07/16.
 xuz[at]live[dot]cn
 流程编辑器 - 新建流程
-->
<template>
    <a-modal title="新建流程"
             :width="1100"
             :visible="visible"
             :maskClosable="false"
             @ok="onSubmit"
             @cancel="$emit('cancel')"
             :confirmLoading="modalLoading"
             class="wf-editor"
             destroyOnClose>
        <a-alert :message="message" banner :type="messageType"/>
        <div id="WFContainer" style="width:1100px;height:500px;margin-bottom:4px" tabindex="0">
        </div>

        <WFObject ref="objectNode" />
        <WFStarNode ref="startNode" />
        <WFEndNode ref="endNode" />
        <WFTransNode ref="transNode" />
        <WFLink ref="linkNode" />
        <WFCommonNode ref="commonNode" />

    </a-modal>
</template>

<script>
import Workflow from './js/WorkFlow'
import WFValidator from './js/WFValidator'
import WFDeparser from './js/WFDeparser'
import WFObject from './WFObject'
import WFStarNode from './WFStarNode'
import WFEndNode from './WFEndNode'
import WFTransNode from './WFTransNode'
import WFLink from './WFLink'
import WFCommonNode from './WFCommonNode'

import qs from 'qs'

export default {
  name: 'WFAdd',
  components: {
    WFObject,
    WFStarNode,
    WFEndNode,
    WFTransNode,
    WFLink,
    WFCommonNode
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalLoading: false,
      message: '流程设计器',
      messageType: 'warning',
      wf: null,
      formData: {
        svgSource: null,
        activitySource: null,
        commentSource: null
      }
    }
  },
  mounted: function () {
  },
  methods: {
    preWFAdd () {
      this.$nextTick(function () {
        this.initWorkFlow()
      })
    },
    onSubmit (event) {
      const that = this
      let forceSave = false
      if (event.altKey && event.ctrlKey) {
        if (confirm('确认启用强制保存功能？')) {
          forceSave = true
        }
      }
      // 不是强制保存时，检查配置数据是否正确
      if (!forceSave) {
        let wfValidator = new WFValidator(this.wf)
        wfValidator.check()
        if (!wfValidator.getCheckResult()) {
          // 有问题
          alert(wfValidator.getErrorList().join('\n'))
          return
        }
      }

      this.wf.setUnSelectLastElement()
      this.wf.onBeforeSave()
      const oSvgJs = this.wf.getSvgJs()
      const oXml = this.wf.getWfXml()
      let wfDeparser = new WFDeparser()
      this.formData.svgSource = wfDeparser.deparse(oSvgJs.node)
      this.formData.activitySource = oXml.getSource()
      this.formData.commentSource = oXml.getCommentsXml()
      this.$http.post('/api/1/workflow/design/save.json', qs.stringify(this.formData)).then(function (data) {
        that.$emit('success')
      })
    },
    initWorkFlow () {
      const that = this
      this.$http.get('/app/workflow/workflow.svg').then(function (content) {

        let placeholder = document.createElement('div')
        placeholder.innerHTML = content
        let svg = placeholder.firstChild
        document.getElementById('WFContainer').appendChild(svg)

        that.wf = new Workflow(that, 'WFDesigner')
      })
    },
    setMessage (message) {
      if (message === '') {
        this.message = '流程设计器'
        this.messageType = 'warning'
      } else {
        this.message = message
        this.messageType = 'error'
      }
    },
    onKeyDown () {
      console.log('onKeyDown')
    },
    onEditObjectNode (wfNode) {
      this.$refs.objectNode.show(wfNode)
    },
    onEditStartNode (wfNode) {
      this.$refs.startNode.show(wfNode)
    },
    onEditCommonNode (wfNode) {
      this.$refs.commonNode.show(wfNode)
    },
    onEditEndNode (wfNode) {
      this.$refs.endNode.show(wfNode)
    },
    onEditTransNode (wfNode) {
      this.$refs.transNode.show(wfNode)
    },
    onEditLinkNode (wfNode) {
      this.$refs.linkNode.show(wfNode)
    }
  }
}
</script>

<style lang="less">
    .wf-editor .ant-modal-body {
        padding: 0 !important;
    }

    #WFDesigner text {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>
